import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M13.3182 8.30727L13.7493 9.07358L14.3419 8.74024L17.5923 6.91185C17.6923 6.8556 17.8159 6.92786 17.8159 7.04259L17.8159 14.2896C17.8159 14.4043 17.6923 14.4765 17.5923 14.4203L14.3419 12.5919L13.7493 12.2586L12.9158 13.7402L13.5084 14.0736L16.7589 15.902C17.9921 16.5957 19.5159 15.7045 19.5159 14.2896L19.5159 7.04259C19.5159 5.62765 17.9921 4.73649 16.7589 5.43017L14.1234 6.91263L13.3182 8.30727Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M1.7 5.03301V15.633H12.3V5.03301H1.7ZM1.5 3.33301C0.671573 3.33301 0 4.00458 0 4.83301V15.833C0 16.6614 0.671573 17.333 1.5 17.333H12.5C13.3284 17.333 14 16.6614 14 15.833V4.83301C14 4.00458 13.3284 3.33301 12.5 3.33301H1.5Z", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const VideoOpenIcon = __component__.exports;
export {
  VideoOpenIcon as default
};
